import React, { Component } from 'react'
import { Tab, Tabs } from "react-bootstrap";
import NeedHelp from '../Elements/NeedHelp';
import { getInitialRoute } from '../../../../../../utils';
import InputField from '../Elements/InputField';
import SubmitFeedRequest from '../Elements/SubmitFeedRequest';
import CheckBoxField from '../Elements/CheckboxField';
import { createFeedAction } from '../../../../../../actions/addFeedActions';

class Pinterest extends Component {

    state = {
        userBoard: "",
        handle: "",
        moderation: false,
        error: false,
        errorMsg: "This field is required",
        errormsgHandle: "This field is required",
        handleError: false,
        filterType: "Handle",
        loading: false
    }
    componentDidMount() {
        this.props.onFilterNameChange(this.state.filterType)
    }

    onTextChange = (e) => this.setState({ [e.target.name]: e.target.value, error: false, handleError: false });
    onManuallyApproveChange = (value) => this.setState({ moderation: value });

    onSubmit = () => {
        const { handle, moderation, userBoard, filterType } = this.state
        const { navigation, feedInfo, hideAddfeed, wallId } = this.props

        if (filterType == 'Handle' && handle.trim().length==0) {
            this.setState({ handleError: true });
        } else if (filterType == 'User Board' && handle.trim().userBoard==0) {
            this.setState({ error: true, errorMsg: "This field is required" });
        } else {
            const ftr = feedInfo && feedInfo.length && feedInfo[0].networkTab && feedInfo[0].networkTab.length ? feedInfo[0].networkTab.findIndex(f => f.feedtype == filterType) : null
            const filterId = feedInfo[0]?.networkTab[ftr]?.filter;

            var obj = {
                wallId: wallId,
                networkId: 5,
                moderation: moderation ? 1 : 0,
                connetedAccount: 0,
                feedType: filterId,
                filter: filterId
            }

            if (filterId == 1) {
                obj['field1'] = handle.split('@').join('')
            } else if (filterId == 12) {
                obj['field12boardurl'] = userBoard

                if (userBoard.includes('pinterest.com')) {
                    let boardUrl = userBoard.replace('www.pinterest.com','in.pinterest.com');
                    let url = boardUrl.split("https://in.pinterest.com/")[1].replace("/", "");
                    if (url) {
                        obj['field1'] = url;
                    } else {
                        this.setState({ errorMsg: 'This field must contain a url.', error: true })
                        return false;
                    }
                } else {
                    this.setState({ errorMsg: 'This field must contain a url.', error: true })
                    return false;
                }
            }

            this.setState({ error: false, handleError: false, loading: true });

            createFeedAction(obj, 5, (feedId) => {
                if (feedId) {
                    navigation(`/moderation/index/${wallId}`);
                    hideAddfeed();
                }
            })
        }
    }

    needSupportLinks = (filterType) => {
        if (getInitialRoute() === 'widget') {
            switch (filterType) {
                case 'Handle':
                    return ['https://vimeo.com/715499635', 'https://taggbox.com/support/how-to-add-pinterest-feed-on-website-using-taggbox/']
                case 'User Board':
                    return ['https://vimeo.com/715499943', 'https://taggbox.com/support/how-to-add-pinterest-feed-on-website-using-taggbox/']
                default:
                    return ['https://vimeo.com/715499635', 'https://taggbox.com/support/how-to-add-pinterest-feed-on-website-using-taggbox/']
            }
        } else {
            switch (filterType) {
                case 'Handle':
                    return ['https://vimeo.com/537163821/caf919e80d', '']
                case 'User Board':
                    return ['https://vimeo.com/541613705/c41f92c8ae', '']
                default:
                    return ['https://vimeo.com/537163821/caf919e80d', '']
            }
        }
    }


    render() {
        const { userBoard, handle, moderation,errormsgHandle, error, handleError, filterType, loading, errorMsg } = this.state;
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="form-body create_feed_wt">
                        <div className="tabbable-tabdrop newRadio d-flex align-items-center justify-content-between flex-wrap feeds_details personalizePopup">
                            <Tabs defaultActiveKey={filterType} id="PinterestFeedTab" onSelect={(e) => this.setState({ filterType: e }, () =>{ this.props.onFilterNameChange(e); })} className="nav-tabs-line nav-tabs-bold w-100 tabDrop mb-3">
                                <Tab eventKey={'Handle'} key={'Handle'} className="nav-link className= p-0" title={<span>{'Handle'}</span>}>
                                    <div className="form-group">
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text">
                                                    <i className={`fas fa-at`}></i>
                                                </span>
                                            </div>
                                            <InputField name={"handle"} id='pinterest_handle' className={`autosearch mycheck form-control`} placeholder="Enter user handle" value={handle} onChangeHandler={(e) => this.onTextChange(e)} />
                                        </div>
                                        {handleError ? <span id="feedsfield1error" className="errorMessage required">{errormsgHandle}</span> : null}
                                    </div>
                                    <div className="hideforBSearch">
                                        <div className="checkbox-inline">
                                            <CheckBoxField isChecked={moderation} onChangeHandler={(e) => this.onManuallyApproveChange(e.target.checked)} name={"moderation"} id="checkbox_handle" />
                                        </div>
                                    </div>
                                </Tab>
                                <Tab eventKey={'User Board'} key={'User Board'} className="nav-link className= p-0" title={<span>{'User Board'}</span>}>
                                    <div className="form-group">
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text">
                                                    <i className={`fas fa-flag`}></i>
                                                </span>
                                            </div>
                                            <InputField name={"userBoard"} id='pinterest_userboard' className={`autosearch mycheck form-control`} placeholder="https://in.pinterest.com/taggbox/taggbox-social-blog/" value={userBoard} onChangeHandler={(e) => this.onTextChange(e)} />
                                        </div>
                                        {error ? <span id="feedsfield1error" className="errorMessage required">{errorMsg}</span> : null}
                                    </div>
                                    <div className="hideforBSearch">
                                        <div className="checkbox-inline">
                                            <CheckBoxField isChecked={moderation} onChangeHandler={(e) => this.onManuallyApproveChange(e.target.checked)} name={"moderation"} id="checkbox_user" />
                                        </div>
                                    </div>
                                </Tab>
                            </Tabs>
                            <div className="form-actions w-100">
                                <div className="f-between flex-wrap border-top pt-3 mt-4">
                                    <NeedHelp text={'Need help in adding feeds?'} videoUrl={this.needSupportLinks(filterType)[0]} supportLink={this.needSupportLinks(filterType)[1]} />
                                    <SubmitFeedRequest onSubmit={this.onSubmit} onBack={this.props.onBack} loading={loading} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Pinterest
